import { Badge } from "components";
import { config } from "constant";
import { Fragment } from "react/jsx-runtime";

export default function FilesLoading() {
  return (
    <Fragment>
      {[...Array(config.loadingLength).keys()].map((key) => (
        <Fragment key={key}>
          <article className="w-full">
            <div className="flex items-center gap-2.5 py-2.5">
              <div className="block size-12 rounded loading" />
              <div className="flex-1 space-y-0.5">
                <div className="w-fit text-sm loading">My resume</div>
                <div className="w-fit text-sm loading">PDF</div>
              </div>
            </div>
            <div className="w-full text-sm py-1 space-y-0.5">
              <div className="w-full loading">Lorem ipsum dolor sit</div>
              <div className="w-full loading">Lorem ipsum dolor sit</div>
              <div className="w-full loading">Lorem ipsum dolor sit</div>
              <div className="w-full loading">Lorem ipsum dolor sit</div>
            </div>
            <div className="flex flex-wrap items-center gap-1 pt-1 pb-2.5">
              {[1, 2, 3].map((e) => (
                <Badge key={e} className="loading">
                  Designer
                </Badge>
              ))}
            </div>
            <div className="w-[4.625rem] h-[2rem] ms-auto loading"></div>
          </article>
          <hr />
        </Fragment>
      ))}
    </Fragment>
  );
}
